export default "__VITE_ASSET__BkgTg$ai__"